import { useRoutes } from 'react-router-dom';
import BaseLayout from '@/layout/BaseLayout';
import Home from '@/pages/Home/Home'
import OpenDsersSellerApi from '@/pages/OpenDsersSellerApi/OpenDsersSellerApi'
import OpenDsersSupplierApi from '@/pages/OpenDsersSupplierApi/OpenDsersSupplierApi'
import OpenSellerApi from '@/pages/OpenSellerApi/OpenSellerApi'
import OpenSupplierApi from '@/pages/OpenSupplierApi/OpenSupplierApi'
import AuthService from '@/pages/AuthService/AuthService'
import StatusAndErrorCodes from '@/pages/StatusAndErrorCodes/StatusAndErrorCodes'

export default () => {
  const element = useRoutes([{
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '/api/channel_app_api',
        element: <OpenSellerApi />
      },
      {
        path: '/api/channel_middle_platform_api',
        element: <OpenDsersSellerApi />
      },
      {
        path: '/api/supplier_app_api',
        element: <OpenSupplierApi />
      },
      {
        path: '/api/supplier_middle_platform_api',
        element: <OpenDsersSupplierApi />
      },
      {
        path: '/auth_service',
        element: <AuthService />
      },
      {
        path: '/status_and_error_codes',
        element: <StatusAndErrorCodes />
      }
    ]
  }]);
  return <>{element}</>
}